import React, { useState, useEffect } from "react";
import "./ProfileProvAdmin.css";
import axios from "axios";
import Swal from "sweetalert2";
import { getTokenCookie } from "../../views/Login/cookie";

const ProfileProvAdmin = () => {
  const [User, setUser] = useState({
    nameAndLastName: "" || "",
    cuit: "" || "",
    email: "" || "",
    placeOfResidence: "" || "",
    street: "" || "",
    numberStreet: "" || "",
  });
  const [load, setLoad] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [originalUser, setOriginalUser] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const token = getTokenCookie();
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_GET_ADMIN_SUPPLIER}${token}`
        );
        const userData = response.data;
        setUser(userData);
        setLoad(false);
        setOriginalUser(User);
      } catch (error) {
        setLoad(false);
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNumericInputChange = (fieldName, value) => {
    // Filtrar caracteres no numéricos solo para CUIT, número y código postal
    let numericValue = value;
    if (["cuit", "numberStreet"].includes(fieldName)) {
      numericValue = value.replace(/[^0-9]/g, "");
    }
    setUser({ ...User, [fieldName]: numericValue });
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const updateUserInfo = async () => {
    try {
      setIsEditing(false);
      const res = await axios.post(
        `${process.env.REACT_APP_UPDATE_ADMIN_SUPPLIER}`,
        { User }
      );
      Swal.fire({
        icon: "success",
        title: "Éxito!",
        text: "Se han actualizado los datos correctamente." || res.data.message,
      });

      setIsEditing(false);

      // Obtener los nuevos datos del usuario y actualizar el estado
      const token = getTokenCookie();
      const response = await axios.get(
        `${process.env.REACT_APP_GET_SUPPLIER}${token}`
      );
      const userData = response.data;
      setUser(userData);
    } catch (error) {}
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  return (
    <div className="allprofile">
      {!load ? (
        <div className="allprovprofile">
          <div className="allformprovfile">
            <div className="dosplayinputProvprofile">
              <div className="boxinputprovprofile">
                <label className="labelformprovprofile">Nombre Completo</label>
                <input
                  className="inputupdateProvprofile"
                  type="text"
                  readOnly={!isEditing}
                  value={User.nameAndLastName || ""}
                  onChange={(e) =>
                    setUser({ ...User, nameAndLastName: e.target.value })
                  }
                />
              </div>
              <div className="boxinputprovprofile">
                <label className="labelformprovprofile">Cuit</label>
                <input
                  className="inputupdateProvprofile"
                  type="text"
                  maxLength={11}
                  readOnly={!isEditing}
                  value={User.cuit || ""}
                  onChange={(e) =>
                    handleNumericInputChange("cuit", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="dosplayinputProvprofile">
              <div className="boxinputprovprofile">
                <label className="labelformprovprofile">Email</label>
                <input
                  className="inputupdateProvprofile"
                  type="email"
                  readOnly={!isEditing}
                  value={User.email || ""}
                  onChange={(e) => setUser({ ...User, email: e.target.value })}
                />
              </div>
              <div className="boxinputprovprofile">
                <label className="labelformprovprofile">
                  Lugar de residencia
                </label>
                <input
                  className="inputupdateProvprofile"
                  type="text"
                  readOnly={!isEditing}
                  value={User.placeOfResidence || ""}
                  onChange={(e) =>
                    setUser({ ...User, placeOfResidence: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="dosplayinputProvprofile">
              <div className="boxinputprovprofile">
                <label className="labelformprovprofile">Calle</label>
                <input
                  className="inputupdateProvprofile"
                  type="text"
                  readOnly={!isEditing}
                  value={User.street || ""}
                  onChange={(e) => setUser({ ...User, street: e.target.value })}
                />
              </div>
              <div className="boxinputprovprofile">
                <label className="labelformprovprofile">Numero</label>
                <input
                  className="inputupdateProvprofile"
                  type="number"
                  readOnly={!isEditing}
                  value={User.numberStreet || ""}
                  onChange={(e) =>
                    handleNumericInputChange("numberStreet", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="boxprovbuttonprfile">
              {!isEditing ? ( // Si no está editando, mostrar el botón "Editar"
                <button className="buttonprovprofile" onClick={handleEditClick}>
                  Editar
                </button>
              ) : (
                // Si está editando, mostrar botones "Actualizar" y "Cancelar"
                <>
                  <button
                    className="buttonprovprofile"
                    onClick={updateUserInfo}
                  >
                    Actualizar
                  </button>
                  <button
                    className="buttonprovprofile"
                    onClick={handleCancelEdit}
                  >
                    Cancelar
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="loader"></div>
      )}
    </div>
  );
};

export default ProfileProvAdmin;
